module.exports = __webpack_public_path__ + "assets/99f692bb74ff8b1024491c0f19d80779.mp3";